export * from './lib/app-client-shared-components-notifications-feature.module';
